enum EmployeeGroupExampleFileNameEnum {
  CsvUploadSamples = "CsvUploadSamples",
  ExcelUploadSamples = "ExcelUploadSamples",
}

export { EmployeeGroupExampleFileNameEnum };
